export { default } from './es/icons/InfoTwoTone';